import { ScrollArea, ScrollBar } from '@/components/scroll-area'
import { Skeleton } from '@/components/skeleton'
import { useMediaQuery } from '@/hooks/use-media-query'
import { Team } from '@/models/team'

interface OurTeamCardProps {
  member: Team
}

function CardText({ member }: OurTeamCardProps) {
  return (
    <>
      <div className="text-bios-secondary flex flex-col px-4 text-center transition-opacity duration-300 md:absolute md:right-2 md:bottom-2 md:left-2 md:rounded-xl md:bg-white/80 md:p-2 md:group-hover:opacity-0">
        <span className="font-bold wrap-break-word md:line-clamp-2">
          {member.name}
        </span>
        <span className="text-sm wrap-break-word md:line-clamp-3">
          {member.profession_position}
        </span>
      </div>
      <div className="text-bios-secondary flex h-52 w-full flex-col items-center px-4 py-2 md:pointer-events-none md:absolute md:bottom-0 md:h-[90%] md:gap-2 md:rounded-lg md:bg-white/90 md:opacity-0 md:transition-opacity md:duration-300 md:ease-in md:group-hover:pointer-events-auto md:group-hover:opacity-100">
        <h4 className="font-bold">Bio</h4>
        <ScrollArea className="max-w-full pr-2">
          <p className="text-sm break-all whitespace-pre-wrap">
            {member.description}
          </p>
        </ScrollArea>
        {member.site_url && (
          <a
            href={member.site_url}
            className="hover:text-bios-800 mt-auto cursor-pointer underline"
            target="_blank"
            rel="noreferrer"
          >
            Saiba mais
          </a>
        )}
      </div>
    </>
  )
}

export function OurTeamCard({ member }: OurTeamCardProps) {
  const isMobile = useMediaQuery('(max-width: 767px)')

  return (
    <div className="group relative flex h-112 w-full min-w-64 flex-col gap-6 rounded-lg bg-white md:h-64 md:min-w-min md:rounded-none md:bg-transparent">
      {member.image_url ? (
        <img
          src={member.image_url}
          className="aspect-square h-56 w-full rounded-t-lg object-cover md:h-full md:rounded-lg"
          alt={`image of team member ${member.name}`}
          loading="lazy"
        />
      ) : (
        <Skeleton className="aspect-square h-56 w-full rounded-b-none md:aspect-auto md:h-full md:rounded-lg" />
      )}

      {isMobile ? (
        <ScrollArea className="md:overflow-x-hidden">
          <CardText member={member} />
          <ScrollBar orientation="vertical" className="md:hidden" />
        </ScrollArea>
      ) : (
        <CardText member={member} />
      )}
    </div>
  )
}
